import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-double-right",
  "use": "icon-chevron-double-right-usage",
  "viewBox": "0 0 18 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 12\" id=\"icon-chevron-double-right\"><g transform=\"translate(-1184 -2097)\"><path d=\"M6.061,12,4,10,8,6,4,2,6.061,0,12,6Z\" transform=\"translate(1190 2097)\" fill=\"currentColor\" /><path d=\"M6.061,12,4,10,8,6,4,2,6.061,0,12,6Z\" transform=\"translate(1180 2097)\" fill=\"currentColor\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol